import { axios } from '@/utils';

export const postTablesService = async (values: any) => {
  try { 
    const { data } = await axios.post('/tables/', values);
    return data.data;
  } catch (e: any) {
    const { message: code } = e;
    const message = errors[code] || 'Something went wrong';
    throw message;
  }
};

const errors: Record<string, string> = {
  'auth/email-already-exists': 'Email already exists',
  'auth/invalid-email': 'Invalid email address',
  'auth/invalid-password': 'Invalid password',
  'auth/invalid-phone-number': 'Invalid phone number',
  'auth/invalid-uid': 'Invalid uid',
  'auth/invalid-user-import': 'Invalid user import',
  'auth/invalid-provider-id': 'Invalid provider id',
  'auth/invalid-verification-code': 'Invalid verification code',
  'auth/phone-number-already-exists': 'Phone Number already exist',
  'not-found-rol': 'rol invalido',
};
